import { useNavigate } from "react-router-dom";
import "./Css/StudentForm.css";
import { useState } from "react";

const AddStudent = () => {
    const navigate = useNavigate();
     const [showPopup, setShowPopup] = useState(false);
  return (
    <div className="student-page">
      {/* Top bar */}
      <div className="top-bar">
 <span className="breadcrumb">
        <span
          className="breadcrumb-link"
          onClick={() => navigate("/dashboard")}  style={{ cursor: "pointer" }}
        >
          विद्यार्थी व्यवस्थापन
        </span>
        &nbsp;&gt;&gt;&nbsp;
        <b>नवीन विद्यार्थी जोडा</b>
      </span>
        <div className="top-buttons">
         <button
  className="btn outline"
  onClick={() => navigate(-1)}
>
  रद्द करा
</button>

<button
            className="btn primary"
            onClick={() => setShowPopup(true)}
          >
            सेव्ह करा
          </button>        </div>
      </div>

      {/* Form Card */}
      <div className="form-card">
        <h2>नवीन विद्यार्थी जोडा</h2>

        <form className="student-form">
          <div className="form-group">
            <label>विद्यार्थी नाव</label>
            <input type="text" placeholder="विद्यार्थी नाव इथे टाका" />
          </div>

          <div className="form-group">
            <label>इयत्ता</label>
            <select>
              <option>इयत्ता निवडा</option>
              <option>५ वी</option>
              <option>६ वी</option>
              <option>७ वी</option>
            </select>
          </div>

          <div className="form-group">
            <label>पालकांचा दूरध्वनी क्रमांक</label>
            <input type="text" placeholder="पालकांचा दूरध्वनी क्रमांक इथे टाका" />
          </div>

          <div className="form-group">
            <label>पत्ता</label>
            <input type="text" placeholder="पत्ता इथे टाका" />
          </div>

          <div className="form-group">
            <label>विद्यार्थी ID</label>
            <input type="text" placeholder="विद्यार्थी ID इथे टाका" />
          </div>

          <div className="form-group">
            <label>ईमेल</label>
            <input type="email" placeholder="ईमेल इथे टाका" />
          </div>

          <div className="form-group">
            <label>जन्मतारीख</label>
            <input type="date" />
          </div>

          <div className="form-group">
            <label>पालकांचे नाव</label>
            <input type="text" placeholder="पालकांचे नाव इथे टाका" />
          </div>

          <div className="form-group">
            <label>शिक्षक नियुक्त करा</label>
            <input type="text" placeholder="शिक्षक नियुक्त करा" />
          </div>

          {/* Upload box */}
          <div className="form-group upload-group">
            <label>फोटो अपलोड करा</label>
            <div className="upload-box">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 40 40" fill="none">
  <path d="M19.1673 31.6615H10.834C8.75482 31.6615 6.9851 30.936 5.52482 29.4852C4.06426 28.0344 3.33398 26.2694 3.33398 24.1902C3.33398 22.2799 3.98676 20.5845 5.29232 19.104C6.59787 17.6231 8.22079 16.8281 10.1611 16.719C10.535 14.2917 11.6513 12.2865 13.5102 10.7031C15.3691 9.11979 17.5326 8.32812 20.0007 8.32812C22.7806 8.32812 25.1423 9.29979 27.0856 11.2431C29.029 13.1865 30.0006 15.5481 30.0006 18.3281V19.9948H31.0265C32.6226 20.0462 33.9618 20.6322 35.044 21.7527C36.1262 22.8735 36.6673 24.232 36.6673 25.8281C36.6673 27.4628 36.1037 28.8437 34.9765 29.9706C33.8495 31.0978 32.4687 31.6615 30.834 31.6615H20.834V19.296L24.334 22.7769L25.5136 21.6294L20.0007 16.1165L14.4877 21.6294L15.6673 22.7769L19.1673 19.296V31.6615Z" fill="#2563EB"/>
</svg>
              <input type="file" />
              <p>
                <span>अपलोड करण्यासाठी क्लिक करा</span> किंवा फाइल ओढून सोडा  
                <br />
                <small>एसव्हीजी, पीएनजी, जेपीजी किंवा जीआयएफ (कमाल आकार: ८००x४०० पिक्सेल)</small>
              </p>
            </div>
          </div>
        </form>
      </div>
       {/* SUCCESS POPUP */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-card">
            <div className="popup-icon">
              <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px" fill="#FFFFFF"><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/></svg>
            </div>

            <h3>विद्यार्थी यशस्वीरित्या जोडले गेले आहेत. !</h3>
            <p>
              विद्यार्थ्याची नोंदणी यशस्वीरित्या पूर्ण झाली आहे.  
              <br />खालील त्याचा विद्यार्थी ID दिला आहे.
            </p>

            <div className="student-id">
              विद्यार्थी ID: <b>STD123456</b>
            </div>

            <button
              className="popup-btn"
              onClick={() => {
                setShowPopup(false);
                navigate(-1); // optional: back to list
              }}
            >
              ठीक आहे
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddStudent;
 
